import { isDefined } from '@sgme/fp';
import { errors } from 'configuration';
import type { NextWorkflowError } from 'models/NextWorkflowError';
import { useIntl } from 'react-intl';
import type { HttpError } from 'utils/http/httpClient.model';

export type ILifeRingError = NextWorkflowError;

export const isStackTrace = (text: string): boolean => {
  return text.length >= errors.minLengthForStackTraceDetection;
};

export type HttpErrorKind = 'Timeout' | 'BadRequest' | 'NotFound';

export function mapErrorKind(error: HttpError): HttpErrorKind | undefined {
  if (error.status === 404) {
    return 'NotFound';
  }
  if (error.status === 400) {
    return 'BadRequest';
  }
  if (error.status === 504) {
    return 'Timeout';
  }
}

export type ErrorType = 'functional' | 'technical';
export type ErrorSubType = 'timeout';
export type TypedError =
  | {
      type: 'functional';
      message?: string;
    }
  | { type: 'technical'; subType?: ErrorSubType; source: string }
  | { type: 'technical'; subType: 'timeout'; timeout: number; source: string };

export function useTypedErrorMessage(props?: TypedError): string | undefined {
  const { formatMessage } = useIntl();
  if (!isDefined(props)) {
    return;
  }
  if (props.type === 'technical') {
    if (props.subType === 'timeout') {
      return formatMessage({ id: 'generic.timeout.message' });
    }
    return formatMessage({ id: 'technical.error' }, { source: props.source });
  }
  return props.message;
}
